import { useAuthControllerFetchSession, useAuthControllerGetTokenByAuthorizationCode } from "@everon-it/api-client/contents-gw";
import { ReactComponent as Logo } from "@assets/icons/everonLogo.svg";
import Button from "@components/atoms/Button";
import { PrivateRoutes } from "@constants/urls";
import useRouter from "@hooks/useRouter";
import { type ErrorResponseType, onSessionTokenReset } from "@utils/api-client-setup";
import useAuthStore from "@store/auth";
import React, { useEffect, useState } from "react";
import useGlobalModal from "@hooks/useGlobalModal";
import { Copyright, FooterWrap, HeaderWrap, LoginWrap, LogoWrap, SubTitle } from "./styles";

const Landing: React.FC = () => {
    const { replace, query } = useRouter();
    const code = query.code as string;
    const [getCode, setGetCode] = useState<string>("");
    const [isTokenReady, setIsTokenReady] = useState<boolean>(false);
    const { setUserInfo } = useAuthStore();
    const { showAlertModal } = useGlobalModal();

    // 토큰 발급 mutation
    const { mutate: getToken } = useAuthControllerGetTokenByAuthorizationCode({
        mutation: {
            onSuccess: () => {
                setIsTokenReady(true);
            },
            onError: (error: ErrorResponseType) => {
                if (error.statusCode === 400 && error.message === "Code not valid") {
                    showAlertModal({
                        title: `로그인 오류가 발생 했어요. 다시 로그인 해주세요.`,
                        onConfirm: () => {
                            onSessionTokenReset();
                        },
                        handleClose: () => {
                            onSessionTokenReset();
                        },
                    });
                } else {
                    showAlertModal({
                        title: error.message,
                        onConfirm: () => onSessionTokenReset(),
                    });
                }
            },
        },
    });

    // 세션 정보 조회 query
    const { data: sessionData, error: sessionError } = useAuthControllerFetchSession({
        query: {
            enabled: isTokenReady || !code,
            retry: false,
            refetchOnWindowFocus: false,
        },
    });

    // code가 있으면 토큰 발급 요청
    useEffect(() => {
        if (code && code !== getCode) {
            setGetCode(code);
            getToken({ data: { code } });
        }
    }, [code, getCode, getToken]);

    // 세션 정보가 있으면 저장 후 메인으로 이동
    useEffect(() => {
        if (sessionData?.row) {
            setUserInfo({ userInfo: sessionData.row });
            replace(PrivateRoutes.Banner);
        }
    }, [sessionData, setUserInfo, replace]);

    // 세션 조회 4xx 에러 시 로그인 페이지로 이동
    useEffect(() => {
        const status = (sessionError as any)?.response?.status;
        if (status && status >= 400 && status < 500) {
            onSessionTokenReset();
        }
    }, [sessionError]);

    return (
        <>
            <LoginWrap>
                <HeaderWrap>
                    <LogoWrap>
                        <Logo />
                    </LogoWrap>
                    <SubTitle>{`언제나 어디서나\n스마트 모빌리티 파트너`}</SubTitle>
                </HeaderWrap>

                <FooterWrap>
                    <Button full buttonType="text" text="잠시만 기다려 주세요" style={{ fontWeight: 500 }} />
                    <Copyright>Copyright © 2022 Everon. All Rights Reserved.</Copyright>
                </FooterWrap>
            </LoginWrap>
        </>
    );
};

export default Landing;
